export const visit = (vm, at) => {
vm(require("foundations-components/lang/ca-es.lyaml"));
at({ "ca-es": { "placeholder": "contenidor" } });
};